export const requestFullRuntimeDocumentHandoff = (href: string) => {
    window.location.assign(href);
};
